import React from 'react';
import cn from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

import { Header } from '../Header';
import styles from './styles.css';

export interface ILayoutProps {
  headerName: string;
  headerDescription: string;
  headerLogoUrl: string;
  testId: string;
  content: React.ReactNode;
  button: React.ReactNode;
}

export const Layout: React.FC<ILayoutProps> = ({
  headerName,
  headerDescription,
  headerLogoUrl,
  button,
  content,
  testId,
}) => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles['container'], styles[deviceType])} data-testid={testId}>
      <Header title={headerName} description={headerDescription} logoUrl={headerLogoUrl} />
      <div className={styles['content-wrapper']}>{content}</div>
      <div className={cn(styles['button-wrapper'], styles[deviceType])}>{button}</div>
    </div>
  );
};

Layout.displayName = 'Layout';
